export default "__VITE_ASSET__CwyRpVsj__"